import api from './api'

export default (resource) => {
  return {
    namespaced: true,
    state: {
      memo:''
    },
    getters: {
      getMemo: (state) => state.memo,
    },
    mutations: {
      SET_MEMO(state, memo) {
        state.memo = memo
      }
    },
    actions: {
      async read({ commit }) {
        const url = `/${resource}/`
        const { data } = await api.get(url)
        commit('SET_MEMO', data)
      },
      async update({ commit }, payload) {
        try {
          const { id } = payload
          const url = `/${resource}/${id}`
          const { data } = await api.put(url, payload)
          commit('SET_MEMO', data)
        } catch (err) {
          throw new Error('Ett problem uppstod när sidan uppdaterads')
        }
      },
    },
  }
}
